import {
  Card,
  CardBody,
  CardHeader,
  Heading,
  SlideFade,
  Text,
  VStack,
} from '@chakra-ui/react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { ContactUsLink } from '~/common/components/ContactUsLink';
import { IndigoLogo } from '~/common/icons/IndigoLogo';
import { useAppContext } from '../../../contexts/AppContext';
import { LoginForm } from './LoginForm';

export const Login = () => {
  const [searchParams] = useSearchParams();
  const { appState, user } = useAppContext();

  if (user && user.roles.length > 0) {
    return <Navigate to={searchParams.get('next') || '/'} />;
  }

  return (
    <VStack
      alignItems="center"
      bgColor={appState.bgColor}
      justifyContent="center"
      minHeight="100vh"
      p={4}
      width="100hv"
    >
      <SlideFade in offsetY="60px">
        <Card minWidth="340px">
          <CardHeader>
            <VStack alignItems="center" spacing={4}>
              <IndigoLogo width="100px" />
              <Heading
                as="h2"
                fontSize="3xl"
                letterSpacing="0px"
                size="sm"
                textTransform="none"
              >
                Let's get started
              </Heading>
            </VStack>
          </CardHeader>
          <CardBody minWidth="340px">
            <LoginForm
              onLogin={() => {
                window.location.reload();
              }}
            />
          </CardBody>
        </Card>
        <VStack alignItems="center" fontSize="lg" mt="4">
          <Text align="center">
            Now available in most of NC, SC & GA
            <br />
            Want us in your area? <ContactUsLink children="Tell us!" />
          </Text>
        </VStack>
      </SlideFade>
    </VStack>
  );
};
